import React from 'react';
import { Input, Button, Select, Textarea, PaperClip, Table, Tooltip } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { ProductService } from 'services';
import { AddIcon, TrashIcon } from 'assets/icons';

interface Props {
	onClose?: any;
}

class PaymentMethods extends React.Component<Props> {

	state = {
		payment_methods: [],
		types: []
	}

	componentDidMount() {
		this.load();
	}

	load = async () => {
		const res: any = await ProductService.getPaymentMethods();
		this.setState({
			payment_methods: res.payment_methods || []
		});
	}

	submit = async (e: any) => {
		e.preventDefault();

		const item = this.state.payment_methods.find((i: any) => !i.name);

		if (item) {
			Globals.showError("Por favor, ingrese el nombre de todos para continuar");
			return;
		}

		await ProductService.savePaymentMethods({
			payment_methods: JSON.stringify(this.state.payment_methods)
		});
		Globals.showSuccess("Se ha guardado la configuración correctamente");
	}

	add = () => {
		let payment_methods: any = [...this.state.payment_methods];
		payment_methods.push({
			name: '',
			bank: '',
			account: '',
			email: '',
			document: '',
			phone: ''
		});
		this.setState({
			payment_methods
		});
	}

	changeItem = (e: any, index: number) => {
		e.preventDefault();
		let payment_methods: any = [...this.state.payment_methods];
		payment_methods[index][e.target.name] = e.target.value;
		this.setState({
			payment_methods
		});
	}

	delete = (e: any, index: number) => {
		e.preventDefault();
		let payment_methods: any = [...this.state.payment_methods];
		payment_methods.splice(index,1);
		this.setState({
			payment_methods
		});
	}
	
	render() {
		return (
			<div id="client-shipping">
				<div className="text-right">
					<button className="btn add-btn" onClick={ this.add }>
						<img src={ AddIcon } />
						<p>Nuevo</p>
					</button>
				</div>
				<Table data={ this.state.payment_methods.length } header={ [] }>
					{
						this.state.payment_methods.map((item: any, index: number) => {
							return (
								<tr>
									<td>
										<Input
											value={ item.name }
											name="name"
											label="Nombre"
											onChange={ (e: any) => this.changeItem(e,index) } />
										<Input
											value={ item.account }
											name="account"
											label="Nº Cuenta"
											onChange={ (e: any) => this.changeItem(e,index) } />
									</td>
									<td>
										<Input
											value={ item.bank }
											name="bank"
											label="Banco"
											onChange={ (e: any) => this.changeItem(e,index) } />
										<Input
											value={ item.document }
											name="document"
											label="Nº Documento"
											onChange={ (e: any) => this.changeItem(e,index) } />
									</td>
									<td>
										<Input
											value={ item.phone }
											name="phone"
											label="Teléfono"
											onChange={ (e: any) => this.changeItem(e,index) } />
										<Input
											value={ item.email }
											name="email"
											label="Correo"
											onChange={ (e: any) => this.changeItem(e,index) } />
									</td>
									<td>
										<Tooltip title="Eliminar">
											<a className="link-icon link-red" href="#" onClick={ (e: any) => this.delete(e,index) }>
												<img src={ TrashIcon } />
											</a>
										</Tooltip>
									</td>
								</tr>
							)
						})
					}
				</Table>
				<div className="text-center">
					<Button className="btn-send" type="submit" onClick={ this.submit }>
						Guardar
					</Button>
				</div>
			</div>
		)
	}
}

export default PaymentMethods;